<div class="sos-content">
    <div>
        <h4>Documentos</h4>
        <app-upload-arquivos [isOrigemSos]="true" [documentos]="documentos" [idFicha]="proposta.id" [cliente]="proposta.cliente" [acceptFiles]="acceptFiles"></app-upload-arquivos>
    </div>
</div>
